import React from 'react';
import AppEvents from './../../pages/App/AppEvents';
// import axios from 'axios';

// import serverClientUtil from '../../utils/serverClientUtil';

import * as getYahooContact from './actions';

const { loadYahoocontact } = getYahooContact;

class Yahoo extends React.Component {
  constructor(props) {
    super(props);
    this.yahooContactsCallsBack = '';
  }

  componentWillUnmount() {
    AppEvents.unsubscribe(this.yahooContactsCallsBack);
  }
  componentDidMount() {
    // const YahooClientID = serverClientUtil.getYahooClientId();
    // const YahooClientSecret = serverClientUtil.getYahooClientSecret();
    // const brand = serverClientUtil.getBrand();
    this.yahooContactsCallsBack = AppEvents.subscribe(AppEvents.EVENT_REGISTER.YAHOO_CONTACTS);
    this.yahoo(this.props.location.query.code);
  }
  formatResponse = (contacts) => {
    const contactsToSend = [];
    if (contacts.contacts && contacts.contacts.length) {
      contacts.contacts.contact.forEach((contact) => {
        const temp = {};
        temp.id = contact.id;
        contact.fields.forEach((field) => {
          if (field.type === 'name') {
          // temp.fullName = field.value.givenName + (field.value.familyName ? (' ' + field.value.familyName) : '');
            temp.firstName = field.value.givenName;
            if (field.value.familyName) {
              temp.lastName = field.value.familyName;
            }
          }
          if (field.type === 'email') {
            temp.emailId = field.value;
          }
          if (field.type === 'yahooid') {
            temp.emailId = field.value;
          }
        });
        contactsToSend.push(temp);
      });
    }
    return contactsToSend;
  }

  yahoo = (code) => {
    loadYahoocontact(code).then((response) => {
      window.opener.postMessage(JSON.stringify({ messageType: AppEvents.EVENT_REGISTER.YAHOO_CONTACTS.toString(), data: this.formatResponse(response.body) }), '*');
      window.close();
    });
  }
  render() {
    return (
      <div><h1>Espere mientras sus contactos se están cargando ...</h1></div>
    );
  }
}

export default Yahoo;
